module.exports = __webpack_public_path__ + "img/chat_type2.a2a91d29.png";